











import { Component, Prop, Vue } from 'vue-property-decorator';
import shapes from '@/common/utils/shapes';
import { SearchResponse } from '@/api/types';
import { bus } from '@/services/busService';

@Component
export default class extends Vue {
  @Prop({ required: true })
  position!: google.maps.LatLngLiteral;

  @Prop({ default: 'black' })
  colour!: string;

  @Prop({ default: null })
  heading!: number | null;

  @Prop({ required: true })
  isVisible!: boolean;

  @Prop({ required: true })
  item!: SearchResponse;

  get assetIcon(): object {
    return this.heading != null ? this.assetMovingIcon() : this.assetStoppedIcon();
  }

  private assetMovingIcon(): object {
    return {
      path: shapes.ARROW_HEAD,
      fillColor: this.colour,
      fillOpacity: 1,
      strokeWeight: 1,
      strokeColor: 'black',
      rotation: this.heading ?? 0,
      scale: 1,
      fixedRotation: true
    };
  }

  private assetStoppedIcon(): object {
    return {
      path: shapes.SQUARE,
      fillColor: this.colour,
      fillOpacity: 1,
      strokeWeight: 1,
      strokeColor: 'black',
      rotation: 0,
      scale: 1
    };
  }

  private openVehicleMarkerInfo(): void {
    bus.$emit('openVehicleMarkerInfo', this.item, this.position);
  }
}
